import { AbstractControl, NG_VALIDATORS, ValidatorFn } from '@angular/forms';

export function numbersOnlyValidator(): ValidatorFn {
  return (control: AbstractControl): {[key: string]: any} => {
    let numbersRegEx: RegExp = new RegExp("^[0-9]*$");
    const isNumeric = numbersRegEx.test(control.value);
    return isNumeric ? null : {'numeric': {value: control.value}};
  };
}

export function doEmailsMatch(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } => {
        return control.get('email').value === control.get('emailCompare').value
            ? null : { 'mismatch': true };
    };
}

export function whiteSpacesValidator(): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } | null => {
    const val = control.value == null ? '' : control.value;
    const isNotSpace = val.trim().length > 0;
    return isNotSpace ? null : {'space': {value : control.value}};
  };
}